// app/components/AnimatedImage.tsx
import React from 'react';
import { useInView } from '../hooks/useInView';

interface AnimatedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  animationClass: string;
}

export function AnimatedImage({ animationClass, className = '', ...props }: AnimatedImageProps) {
  const { ref, isInView } = useInView({ threshold: 0.3 });
  return (
    <img
      ref={ref as React.RefObject<HTMLImageElement>}
      {...props}
      loading="lazy"
      decoding="async"
      className={`${className} ${isInView ? animationClass : 'opacity-0'}`}
    />
  );
}
